export const cities = [
              {
                "text": "Bangalore",
                "link": "https://www.swiggy.com/city/bangalore"
              },
              {
                "text": "Gurgaon",
                "link": "https://www.swiggy.com/city/gurgaon"
              },
              {
                "text": "Hyderabad",
                "link": "https://www.swiggy.com/city/hyderabad"
              },
              {
                "text": "Delhi",
                "link": "https://www.swiggy.com/city/delhi"
              },
              {
                "text": "Mumbai",
                "link": "https://www.swiggy.com/city/mumbai"
              },
              {
                "text": "Pune",
                "link": "https://www.swiggy.com/city/pune"
              },
              {
                "text": "Kolkata",
                "link": "https://www.swiggy.com/city/kolkata"
              },
              {
                "text": "Chennai",
                "link": "https://www.swiggy.com/city/chennai"
              },
              {
                "text": "Ahmedabad",
                "link": "https://www.swiggy.com/city/ahmedabad"
              },
              {
                "text": "Chandigarh",
                "link": "https://www.swiggy.com/city/chandigarh"
              },
              {
                "text": "Jaipur",
                "link": "https://www.swiggy.com/city/jaipur"
              },
              {
                "text": "Kochi",
                "link": "https://www.swiggy.com/city/kochi"
              },
              {
                "text": "Coimbatore",
                "link": "https://www.swiggy.com/city/coimbatore"
              },
              {
                "text": "Lucknow",
                "link": "https://www.swiggy.com/city/lucknow"
              },
              {
                "text": "Nagpur",
                "link": "https://www.swiggy.com/city/nagpur"
              },
              {
                "text": "Vadodara",
                "link": "https://www.swiggy.com/city/vadodara"
              },
              {
                "text": "Indore",
                "link": "https://www.swiggy.com/city/indore"
              },
              {
                "text": "Guwahati",
                "link": "https://www.swiggy.com/city/guwahati"
              },
              {
                "text": "Vizag",
                "link": "https://www.swiggy.com/city/vizag"
              },
              {
                "text": "Surat",
                "link": "https://www.swiggy.com/city/surat"
              },
              {
                "text": "Dehradun",
                "link": "https://www.swiggy.com/city/dehradun"
              },
              {
                "text": "Noida",
                "link": "https://www.swiggy.com/city/noida"
              },
              {
                "text": "Ludhiana",
                "link": "https://www.swiggy.com/city/ludhiana"
              },
              {
                "text": "Trichy",
                "link": "https://www.swiggy.com/city/trichy"
              },
              {
                "text": "Vijayawada",
                "link": "https://www.swiggy.com/city/vijayawada"
              },
              {
                "text": "Kanpur",
                "link": "https://www.swiggy.com/city/kanpur"
              },
              {
                "text": "Mysore",
                "link": "https://www.swiggy.com/city/mysore"
              },
              {
                "text": "Nashik",
                "link": "https://www.swiggy.com/city/nashik"
              },
              {
                "text": "Udaipur",
                "link": "https://www.swiggy.com/city/udaipur"
              },
              {
                "text": "Pondicherry",
                "link": "https://www.swiggy.com/city/pondicherry"
              },
              {
                "text": "Agra",
                "link": "https://www.swiggy.com/city/agra"
              },
              {
                "text": "Aurangabad",
                "link": "https://www.swiggy.com/city/aurangabad"
              },
              {
                "text": "Jalandhar",
                "link": "https://www.swiggy.com/city/jalandhar"
              },
              {
                "text": "Kota",
                "link": "https://www.swiggy.com/city/kota"
              },
              {
                "text": "Madurai",
                "link": "https://www.swiggy.com/city/madurai"
              },
              {
                "text": "Allahabad",
                "link": "https://www.swiggy.com/city/allahabad"
              },
              {
                "text": "Manipal",
                "link": "https://www.swiggy.com/city/manipal"
              },
              {
                "text": "Amritsar",
                "link": "https://www.swiggy.com/city/amritsar"
              },
              {
                "text": "Bareilly",
                "link": "https://www.swiggy.com/city/bareilly"
              },
              {
                "text": "Meerut",
                "link": "https://www.swiggy.com/city/meerut"
              },
              {
                "text": "Bhopal",
                "link": "https://www.swiggy.com/city/bhopal"
              },
              {
                "text": "Ooty",
                "link": "https://www.swiggy.com/city/ooty"
              },
              {
                "text": "Bhubaneswar",
                "link": "https://www.swiggy.com/city/bhubaneswar"
              },
              {
                "text": "Raipur",
                "link": "https://www.swiggy.com/city/raipur"
              },
              {
                "text": "Bikaner",
                "link": "https://www.swiggy.com/city/bikaner"
              },
              {
                "text": "Rajkot",
                "link": "https://www.swiggy.com/city/rajkot"
              },
              {
                "text": "Kozhikode",
                "link": "https://www.swiggy.com/city/kozhikode"
              },
              {
                "text": "Central Goa",
                "link": "https://www.swiggy.com/city/central-goa"
              },
              {
                "text": "Sirsa",
                "link": "https://www.swiggy.com/city/sirsa"
              },
              {
                "text": "Gwalior",
                "link": "https://www.swiggy.com/city/gwalior"
              },
              {
                "text": "Thrissur",
                "link": "https://www.swiggy.com/city/thrissur"
              },
              {
                "text": "Kharagpur",
                "link": "https://www.swiggy.com/city/kharagpur"
              },
              {
                "text": "Tirupati",
                "link": "https://www.swiggy.com/city/tirupati"
              },
              {
                "text": "Tirupur",
                "link": "https://www.swiggy.com/city/tirupur"
              },
              {
                "text": "Vellore",
                "link": "https://www.swiggy.com/city/vellore"
              },
              {
                "text": "Thiruvananthapuram",
                "link": "https://www.swiggy.com/city/thiruvananthapuram"
              },
              {
                "text": "Warangal",
                "link": "https://www.swiggy.com/city/warangal"
              },
              {
                "text": "Varanasi",
                "link": "https://www.swiggy.com/city/varanasi"
              },
              {
                "text": "Mangaluru",
                "link": "https://www.swiggy.com/city/mangaluru"
              },
              {
                "text": "Patna",
                "link": "https://www.swiggy.com/city/patna"
              },
              {
                "text": "Ranchi",
                "link": "https://www.swiggy.com/city/ranchi"
              },
              {
                "text": "Faridabad",
                "link": "https://www.swiggy.com/city/faridabad"
              },
              {
                "text": "Guntur",
                "link": "https://www.swiggy.com/city/guntur"
              },
              {
                "text": "Ujjain",
                "link": "https://www.swiggy.com/city/ujjain"
              },
              {
                "text": "Patiala",
                "link": "https://www.swiggy.com/city/patiala"
              },
              {
                "text": "Karnal",
                "link": "https://www.swiggy.com/city/karnal"
              },
              {
                "text": "Kakinada",
                "link": "https://www.swiggy.com/city/kakinada"
              },
              {
                "text": "Rajahmundry",
                "link": "https://www.swiggy.com/city/rajahmundry"
              },
              {
                "text": "Bilaspur",
                "link": "https://www.swiggy.com/city/bilaspur"
              },
              {
                "text": "Bhilai",
                "link": "https://www.swiggy.com/city/bhilai"
              },
              {
                "text": "Anand",
                "link": "https://www.swiggy.com/city/anand"
              },
              {
                "text": "Bhavnagar",
                "link": "https://www.swiggy.com/city/bhavnagar"
              },
              {
                "text": "Jammu",
                "link": "https://www.swiggy.com/city/jammu"
              },
              {
                "text": "Muktsar",
                "link": "https://www.swiggy.com/city/muktsar"
              },
              {
                "text": "Panipat",
                "link": "https://www.swiggy.com/city/panipat"
              },
              {
                "text": "Jamshedpur",
                "link": "https://www.swiggy.com/city/jamshedpur"
              },
              {
                "text": "Dhanbad",
                "link": "https://www.swiggy.com/city/dhanbad"
              },
              {
                "text": "Bokaro",
                "link": "https://www.swiggy.com/city/bokaro"
              },
              {
                "text": "Hubli",
                "link": "https://www.swiggy.com/city/hubli"
              },
              {
                "text": "Belgaum",
                "link": "https://www.swiggy.com/city/belgaum"
              },
              {
                "text": "Jabalpur",
                "link": "https://www.swiggy.com/city/jabalpur"
              },
              {
                "text": "Kolhapur",
                "link": "https://www.swiggy.com/city/kolhapur"
              },
              {
                "text": "Solapur",
                "link": "https://www.swiggy.com/city/solapur"
              },
              {
                "text": "Shillong",
                "link": "https://www.swiggy.com/city/shillong"
              },
              {
                "text": "Cuttack",
                "link": "https://www.swiggy.com/city/cuttack"
              },
              {
                "text": "Aligarh",
                "link": "https://www.swiggy.com/city/aligarh"
              },
              {
                "text": "Salem",
                "link": "https://www.swiggy.com/city/salem"
              },
              {
                "text": "Agartala",
                "link": "https://www.swiggy.com/city/agartala"
              },
              {
                "text": "Jodhpur",
                "link": "https://www.swiggy.com/city/jodhpur"
              },
              {
                "text": "Ajmer",
                "link": "https://www.swiggy.com/city/ajmer"
              },
              {
                "text": "Jhansi",
                "link": "https://www.swiggy.com/city/jhansi"
              },
              {
                "text": "Gorakhpur",
                "link": "https://www.swiggy.com/city/gorakhpur"
              },
              {
                "text": "Thanjavur",
                "link": "https://www.swiggy.com/city/thanjavur"
              },
              {
                "text": "Erode",
                "link": "https://www.swiggy.com/city/erode"
              },
              {
                "text": "Nellore",
                "link": "https://www.swiggy.com/city/nellore"
              },
              {
                "text": "Rourkela",
                "link": "https://www.swiggy.com/city/rourkela"
              },
              {
                "text": "Anantapur",
                "link": "https://www.swiggy.com/city/anantapur"
              },
              {
                "text": "Kurnool",
                "link": "https://www.swiggy.com/city/kurnool"
              },
              {
                "text": "Ahmednagar",
                "link": "https://www.swiggy.com/city/ahmednagar"
              },
              {
                "text": "Phagwara",
                "link": "https://www.swiggy.com/city/phagwara"
              },
              {
                "text": "Ambala",
                "link": "https://www.swiggy.com/city/ambala"
              },
              {
                "text": "Ballari",
                "link": "https://www.swiggy.com/city/ballari"
              },
              {
                "text": "Saharanpur",
                "link": "https://www.swiggy.com/city/saharanpur"
              },
              {
                "text": "Tirunelveli",
                "link": "https://www.swiggy.com/city/tirunelveli"
              },
              {
                "text": "Bathinda",
                "link": "https://www.swiggy.com/city/bathinda"
              },
              {
                "text": "Mathura",
                "link": "https://www.swiggy.com/city/mathura"
              },
              {
                "text": "Haridwar",
                "link": "https://www.swiggy.com/city/haridwar"
              },
              {
                "text": "Ratnagiri",
                "link": "https://www.swiggy.com/city/ratnagiri"
              },
              {
                "text": "Sangli",
                "link": "https://www.swiggy.com/city/sangli"
              },
              {
                "text": "Amravati",
                "link": "https://www.swiggy.com/city/amravati"
              },
              {
                "text": "Rishikesh",
                "link": "https://www.swiggy.com/city/rishikesh"
              },
              {
                "text": "Nagercoil",
                "link": "https://www.swiggy.com/city/nagercoil"
              },
              {
                "text": "KanyaKumari",
                "link": "https://www.swiggy.com/city/kanyakumari"
              },
              {
                "text": "Kadapa",
                "link": "https://www.swiggy.com/city/kadapa"
              },
              {
                "text": "Nizamabad",
                "link": "https://www.swiggy.com/city/nizamabad"
              },
              {
                "text": "Shivamogga",
                "link": "https://www.swiggy.com/city/shivamogga"
              },
              {
                "text": "Davanagere",
                "link": "https://www.swiggy.com/city/davanagere"
              },
              {
                "text": "Roorkee",
                "link": "https://www.swiggy.com/city/roorkee"
              },
              {
                "text": "Nanded",
                "link": "https://www.swiggy.com/city/nanded"
              },
              {
                "text": "Rewa",
                "link": "https://www.swiggy.com/city/rewa"
              },
              {
                "text": "Satna",
                "link": "https://www.swiggy.com/city/satna"
              },
              {
                "text": "Shimla",
                "link": "https://www.swiggy.com/city/shimla"
              },
              {
                "text": "Muzaffarpur",
                "link": "https://www.swiggy.com/city/muzaffarpur"
              },
              {
                "text": "Valsad",
                "link": "https://www.swiggy.com/city/valsad"
              },
              {
                "text": "Vapi",
                "link": "https://www.swiggy.com/city/vapi"
              },
              {
                "text": "Chhapra",
                "link": "https://www.swiggy.com/city/chhapra"
              },
              {
                "text": "Dharamshala",
                "link": "https://www.swiggy.com/city/dharamshala"
              },
              {
                "text": "Kollam",
                "link": "https://www.swiggy.com/city/kollam"
              },
              {
                "text": "Silchar",
                "link": "https://www.swiggy.com/city/silchar"
              },
              {
                "text": "Alappuzha",
                "link": "https://www.swiggy.com/city/alappuzha"
              },
              {
                "text": "Sonipat",
                "link": "https://www.swiggy.com/city/sonipat"
              },
              {
                "text": "Rohtak",
                "link": "https://www.swiggy.com/city/rohtak"
              },
              {
                "text": "Mehsana",
                "link": "https://www.swiggy.com/city/mehsana"
              },
              {
                "text": "Kullu",
                "link": "https://www.swiggy.com/city/kullu"
              },
              {
                "text": "Dhule",
                "link": "https://www.swiggy.com/city/dhule"
              },
              {
                "text": "Dharwad",
                "link": "https://www.swiggy.com/city/dharwad"
              },
              {
                "text": "Latur",
                "link": "https://www.swiggy.com/city/latur"
              },
              {
                "text": "Vizianagaram",
                "link": "https://www.swiggy.com/city/vizianagaram"
              },
              {
                "text": "Khammam",
                "link": "https://www.swiggy.com/city/khammam"
              },
              {
                "text": "Hampi",
                "link": "https://www.swiggy.com/city/hampi"
              },
              {
                "text": "Nainital",
                "link": "https://www.swiggy.com/city/nainital"
              },
              {
                "text": "Akola",
                "link": "https://www.swiggy.com/city/akola"
              },
              {
                "text": "Kalaburagi",
                "link": "https://www.swiggy.com/city/kalaburagi"
              },
              {
                "text": "Gaya",
                "link": "https://www.swiggy.com/city/gaya"
              },
              {
                "text": "Muzaffarnagar",
                "link": "https://www.swiggy.com/city/muzaffarnagar"
              },
              {
                "text": "Dewas",
                "link": "https://www.swiggy.com/city/dewas"
              },
              {
                "text": "Korba",
                "link": "https://www.swiggy.com/city/korba"
              },
              {
                "text": "Mussoorie",
                "link": "https://www.swiggy.com/city/mussoorie"
              },
              {
                "text": "Jalgaon",
                "link": "https://www.swiggy.com/city/jalgaon"
              },
              {
                "text": "Yamuna Nagar",
                "link": "https://www.swiggy.com/city/yamuna-nagar"
              },
              {
                "text": "Bhagalpur",
                "link": "https://www.swiggy.com/city/bhagalpur"
              },
              {
                "text": "Hapur",
                "link": "https://www.swiggy.com/city/hapur"
              },
              {
                "text": "Morena",
                "link": "https://www.swiggy.com/city/morena"
              },
              {
                "text": "Hassan",
                "link": "https://www.swiggy.com/city/hassan"
              },
              {
                "text": "Hisar",
                "link": "https://www.swiggy.com/city/hisar"
              },
              {
                "text": "Godhra",
                "link": "https://www.swiggy.com/city/godhra"
              },
              {
                "text": "Kolar ",
                "link": "https://www.swiggy.com/city/kolar"
              },
              {
                "text": "Rampur",
                "link": "https://www.swiggy.com/city/rampur"
              },
              {
                "text": "Sitapur",
                "link": "https://www.swiggy.com/city/sitapur"
              },
              {
                "text": "Etawah",
                "link": "https://www.swiggy.com/city/etawah"
              },
              {
                "text": "Porbandar",
                "link": "https://www.swiggy.com/city/porbandar"
              },
              {
                "text": "Nadiad",
                "link": "https://www.swiggy.com/city/nadiad"
              },
              {
                "text": "Sagar",
                "link": "https://www.swiggy.com/city/sagar"
              },
              {
                "text": "Morbi",
                "link": "https://www.swiggy.com/city/morbi"
              },
              {
                "text": "Chhindwara",
                "link": "https://www.swiggy.com/city/chhindwara"
              },
              {
                "text": "Tumakuru",
                "link": "https://www.swiggy.com/city/tumakuru"
              },
              {
                "text": "Singrauli",
                "link": "https://www.swiggy.com/city/singrauli"
              },
              {
                "text": "Thoothukudi",
                "link": "https://www.swiggy.com/city/thoothukudi"
              },
              {
                "text": "Katni",
                "link": "https://www.swiggy.com/city/katni"
              },
              {
                "text": "Khandwa",
                "link": "https://www.swiggy.com/city/khandwa"
              },
              {
                "text": "Eluru",
                "link": "https://www.swiggy.com/city/eluru"
              },
              {
                "text": "Malappuram",
                "link": "https://www.swiggy.com/city/malappuram"
              },
              {
                "text": "Dibrugarh",
                "link": "https://www.swiggy.com/city/dibrugarh"
              },
              {
                "text": "Deoghar",
                "link": "https://www.swiggy.com/city/deoghar"
              },
              {
                "text": "Khanna",
                "link": "https://www.swiggy.com/city/khanna"
              },
              {
                "text": "Bidar",
                "link": "https://www.swiggy.com/city/bidar"
              },
              {
                "text": "Anantnag",
                "link": "https://www.swiggy.com/city/anantnag"
              },
              {
                "text": "Madikeri",
                "link": "https://www.swiggy.com/city/madikeri"
              },
              {
                "text": "Haldwani",
                "link": "https://www.swiggy.com/city/haldwani"
              },
              {
                "text": "Panchkula",
                "link": "https://www.swiggy.com/city/panchkula"
              },
              {
                "text": "Farrukhabad",
                "link": "https://www.swiggy.com/city/farrukhabad"
              },
              {
                "text": "Malegaon",
                "link": "https://www.swiggy.com/city/malegaon"
              },
              {
                "text": "Dindigul",
                "link": "https://www.swiggy.com/city/dindigul"
              },
              {
                "text": "Shahjahanpur",
                "link": "https://www.swiggy.com/city/shahjahanpur"
              },
              {
                "text": "Beed",
                "link": "https://www.swiggy.com/city/beed"
              },
              {
                "text": "Junagadh",
                "link": "https://www.swiggy.com/city/junagadh"
              },
              {
                "text": "Asansol",
                "link": "https://www.swiggy.com/city/asansol"
              },
              {
                "text": "Beawar",
                "link": "https://www.swiggy.com/city/beawar"
              },
              {
                "text": "Kishangarh",
                "link": "https://www.swiggy.com/city/kishangarh"
              },
              {
                "text": "Budhwal",
                "link": "https://www.swiggy.com/city/budhwal"
              },
              {
                "text": "Parbhani",
                "link": "https://www.swiggy.com/city/parbhani"
              },
              {
                "text": "Gondia",
                "link": "https://www.swiggy.com/city/gondia"
              },
              {
                "text": "Ichalkaranji",
                "link": "https://www.swiggy.com/city/ichalkaranji"
              },
              {
                "text": "Jalna",
                "link": "https://www.swiggy.com/city/jalna"
              },
              {
                "text": "Yavatmal",
                "link": "https://www.swiggy.com/city/yavatmal"
              },
              {
                "text": "Shivpuri",
                "link": "https://www.swiggy.com/city/shivpuri"
              },
              {
                "text": "Moga",
                "link": "https://www.swiggy.com/city/moga"
              },
              {
                "text": "Abohar",
                "link": "https://www.swiggy.com/city/abohar"
              },
              {
                "text": "Adoni",
                "link": "https://www.swiggy.com/city/adoni"
              },
              {
                "text": "Madanapalle",
                "link": "https://www.swiggy.com/city/madanapalle"
              },
              {
                "text": "Tiruvannamalai",
                "link": "https://www.swiggy.com/city/tiruvannamalai"
              },
              {
                "text": "Satara",
                "link": "https://www.swiggy.com/city/satara"
              },
              {
                "text": "Ambur",
                "link": "https://www.swiggy.com/city/ambur"
              },
              {
                "text": "Karimnagar",
                "link": "https://www.swiggy.com/city/karimnagar"
              },
              {
                "text": "Ratlam",
                "link": "https://www.swiggy.com/city/ratlam"
              },
              {
                "text": "Moradabad",
                "link": "https://www.swiggy.com/city/moradabad"
              },
              {
                "text": "Machilipatnam",
                "link": "https://www.swiggy.com/city/machilipatnam"
              },
              {
                "text": "Ongole",
                "link": "https://www.swiggy.com/city/ongole"
              },
              {
                "text": "Kottayam",
                "link": "https://www.swiggy.com/city/kottayam"
              },
              {
                "text": "Darbhanga",
                "link": "https://www.swiggy.com/city/darbhanga"
              },
              {
                "text": "Kurukshetra",
                "link": "https://www.swiggy.com/city/kurukshetra"
              },
              {
                "text": "Unnao",
                "link": "https://www.swiggy.com/city/unnao"
              },
              {
                "text": "Bulandshahr",
                "link": "https://www.swiggy.com/city/bulandshahr"
              },
              {
                "text": "Durgapur",
                "link": "https://www.swiggy.com/city/durgapur"
              },
              {
                "text": "Siliguri",
                "link": "https://www.swiggy.com/city/siliguri"
              },
              {
                "text": "Pali",
                "link": "https://www.swiggy.com/city/pali"
              },
              {
                "text": "Tadepalligudem",
                "link": "https://www.swiggy.com/city/tadepalligudem"
              },
              {
                "text": "Ramagundam",
                "link": "https://www.swiggy.com/city/ramagundam"
              },
              {
                "text": "Mahbubnagar",
                "link": "https://www.swiggy.com/city/mahbubnagar"
              },
              {
                "text": "Bhiwani",
                "link": "https://www.swiggy.com/city/bhiwani"
              },
              {
                "text": "Cuddalore",
                "link": "https://www.swiggy.com/city/cuddalore"
              },
              {
                "text": "Kaithal",
                "link": "https://www.swiggy.com/city/kaithal"
              },
              {
                "text": "Jagtial",
                "link": "https://www.swiggy.com/city/jagtial"
              },
              {
                "text": "Palakkad",
                "link": "https://www.swiggy.com/city/palakkad"
              },
              {
                "text": "Guna",
                "link": "https://www.swiggy.com/city/guna"
              },
              {
                "text": "Kumbakonam",
                "link": "https://www.swiggy.com/city/kumbakonam"
              },
              {
                "text": "Maunath Bhanjan",
                "link": "https://www.swiggy.com/city/maunath-bhanjan"
              },
              {
                "text": "Baripada",
                "link": "https://www.swiggy.com/city/baripada"
              },
              {
                "text": "Orai",
                "link": "https://www.swiggy.com/city/orai"
              },
              {
                "text": "Bhadrak",
                "link": "https://www.swiggy.com/city/bhadrak"
              },
              {
                "text": "Batala",
                "link": "https://www.swiggy.com/city/batala"
              },
              {
                "text": "Firozpur",
                "link": "https://www.swiggy.com/city/firozpur"
              },
              {
                "text": "Barnala",
                "link": "https://www.swiggy.com/city/barnala"
              },
              {
                "text": "Raigarh",
                "link": "https://www.swiggy.com/city/raigarh"
              },
              {
                "text": "Nagaon",
                "link": "https://www.swiggy.com/city/nagaon"
              },
              {
                "text": "Mainpuri",
                "link": "https://www.swiggy.com/city/mainpuri"
              },
              {
                "text": "Balurghat",
                "link": "https://www.swiggy.com/city/balurghat"
              },
              {
                "text": "Giridih",
                "link": "https://www.swiggy.com/city/giridih"
              },
              {
                "text": "Ghazipur",
                "link": "https://www.swiggy.com/city/ghazipur"
              },
              {
                "text": "Jagdalpur",
                "link": "https://www.swiggy.com/city/jagdalpur"
              },
              {
                "text": "Vidisha",
                "link": "https://www.swiggy.com/city/vidisha"
              },
              {
                "text": "Dimapur",
                "link": "https://www.swiggy.com/city/dimapur"
              },
              {
                "text": "Shikohabad",
                "link": "https://www.swiggy.com/city/shikohabad"
              },
              {
                "text": "Imphal",
                "link": "https://www.swiggy.com/city/imphal"
              },
              {
                "text": "Lakhimpur",
                "link": "https://www.swiggy.com/city/lakhimpur"
              },
              {
                "text": "Rudrapur",
                "link": "https://www.swiggy.com/city/rudrapur"
              },
              {
                "text": "Ambikapur",
                "link": "https://www.swiggy.com/city/ambikapur"
              },
              {
                "text": "Damoh",
                "link": "https://www.swiggy.com/city/damoh"
              },
              {
                "text": "Rae Bareli",
                "link": "https://www.swiggy.com/city/rae-bareli"
              },
              {
                "text": "Tinsukia",
                "link": "https://www.swiggy.com/city/tinsukia"
              },
              {
                "text": "Rajapalayam",
                "link": "https://www.swiggy.com/city/rajapalayam"
              },
              {
                "text": "Rajnandgaon",
                "link": "https://www.swiggy.com/city/rajnandgaon"
              },
              {
                "text": "Kashipur",
                "link": "https://www.swiggy.com/city/kashipur"
              },
              {
                "text": "Ranibennur",
                "link": "https://www.swiggy.com/city/ranibennur"
              },
              {
                "text": "Burhanpur",
                "link": "https://www.swiggy.com/city/burhanpur"
              },
              {
                "text": "Bhadravati",
                "link": "https://www.swiggy.com/city/bhadravati"
              },
              {
                "text": "Chittoor",
                "link": "https://www.swiggy.com/city/chittoor"
              },
              {
                "text": "Pudukkottai",
                "link": "https://www.swiggy.com/city/pudukkottai"
              },
              {
                "text": "Hardoi",
                "link": "https://www.swiggy.com/city/hardoi"
              },
              {
                "text": "Basti",
                "link": "https://www.swiggy.com/city/basti"
              },
              {
                "text": "Karaikkudi",
                "link": "https://www.swiggy.com/city/karaikkudi"
              },
              {
                "text": "Lalitpur",
                "link": "https://www.swiggy.com/city/lalitpur"
              },
              {
                "text": "Hospet",
                "link": "https://www.swiggy.com/city/hospet"
              },
              {
                "text": "Budaun",
                "link": "https://www.swiggy.com/city/budaun"
              },
              {
                "text": "Neemuch",
                "link": "https://www.swiggy.com/city/neemuch"
              },
              {
                "text": "Pilibhit",
                "link": "https://www.swiggy.com/city/pilibhit"
              },
              {
                "text": "Amroha",
                "link": "https://www.swiggy.com/city/amroha"
              },
              {
                "text": "Barshi",
                "link": "https://www.swiggy.com/city/barshi"
              },
              {
                "text": "Sri Ganganagar",
                "link": "https://www.swiggy.com/city/sri-ganganagar"
              },
              {
                "text": "Wardha",
                "link": "https://www.swiggy.com/city/wardha"
              },
              {
                "text": "Sehore",
                "link": "https://www.swiggy.com/city/sehore"
              },
              {
                "text": "Bhimavaram",
                "link": "https://www.swiggy.com/city/bhimavaram"
              },
              {
                "text": "Hanumangarh",
                "link": "https://www.swiggy.com/city/hanumangarh"
              },
              {
                "text": "Pathankot",
                "link": "https://www.swiggy.com/city/pathankot"
              },
              {
                "text": "Puri",
                "link": "https://www.swiggy.com/city/puri"
              },
              {
                "text": "Fatehpur",
                "link": "https://www.swiggy.com/city/fatehpur"
              },
              {
                "text": "Surendranagar Dudhrej",
                "link": "https://www.swiggy.com/city/surendranagar-dudhrej"
              },
              {
                "text": "Jamnagar",
                "link": "https://www.swiggy.com/city/jamnagar"
              },
              {
                "text": "Bhuj",
                "link": "https://www.swiggy.com/city/bhuj"
              },
              {
                "text": "Gandhidham",
                "link": "https://www.swiggy.com/city/gandhidham"
              },
              {
                "text": "Bharuch",
                "link": "https://www.swiggy.com/city/bharuch"
              },
              {
                "text": "Navsari",
                "link": "https://www.swiggy.com/city/navsari"
              },
              {
                "text": "Amreli",
                "link": "https://www.swiggy.com/city/amreli"
              },
              {
                "text": "Palanpur",
                "link": "https://www.swiggy.com/city/palanpur"
              },
              {
                "text": "Bhilwara",
                "link": "https://www.swiggy.com/city/bhilwara"
              },
              {
                "text": "Suratgarh",
                "link": "https://www.swiggy.com/city/suratgarh"
              },
              {
                "text": "Sikar",
                "link": "https://www.swiggy.com/city/sikar"
              },
              {
                "text": "Churu",
                "link": "https://www.swiggy.com/city/churu"
              },
              {
                "text": "Alwar",
                "link": "https://www.swiggy.com/city/alwar"
              },
              {
                "text": "Bhiwadi",
                "link": "https://www.swiggy.com/city/bhiwadi"
              },
              {
                "text": "Bharatpur",
                "link": "https://www.swiggy.com/city/bharatpur"
              },
              {
                "text": "Mount Abu",
                "link": "https://www.swiggy.com/city/mount-abu"
              },
              {
                "text": "Bundi",
                "link": "https://www.swiggy.com/city/bundi"
              },
              {
                "text": "Sawai Madhopur",
                "link": "https://www.swiggy.com/city/sawai-madhopur"
              },
              {
                "text": "Purulia",
                "link": "https://www.swiggy.com/city/purulia"
              },
              {
                "text": "Bardhaman",
                "link": "https://www.swiggy.com/city/bardhaman"
              },
              {
                "text": "Raniganj",
                "link": "https://www.swiggy.com/city/raniganj"
              },
              {
                "text": "Darjeeling",
                "link": "https://www.swiggy.com/city/darjeeling"
              },
              {
                "text": "Jalpaiguri",
                "link": "https://www.swiggy.com/city/jalpaiguri"
              },
              {
                "text": "Chittorgarh",
                "link": "https://www.swiggy.com/city/chittorgarh"
              },
              {
                "text": "Dholpur",
                "link": "https://www.swiggy.com/city/dholpur"
              },
              {
                "text": "Uluberia",
                "link": "https://www.swiggy.com/city/uluberia"
              },
              {
                "text": "Nabadwip",
                "link": "https://www.swiggy.com/city/nabadwip"
              },
              {
                "text": "Bongaon",
                "link": "https://www.swiggy.com/city/bongaon"
              },
              {
                "text": "Kanchrapara",
                "link": "https://www.swiggy.com/city/kanchrapara"
              },
              {
                "text": "Bankura",
                "link": "https://www.swiggy.com/city/bankura"
              },
              {
                "text": "Habra",
                "link": "https://www.swiggy.com/city/habra"
              },
              {
                "text": "Firozabad",
                "link": "https://www.swiggy.com/city/firozabad"
              },
              {
                "text": "Nalgonda",
                "link": "https://www.swiggy.com/city/nalgonda"
              },
              {
                "text": "Chandrapur",
                "link": "https://www.swiggy.com/city/chandrapur"
              },
              {
                "text": "Bijapur",
                "link": "https://www.swiggy.com/city/bijapur"
              },
              {
                "text": "Bhusawal",
                "link": "https://www.swiggy.com/city/bhusawal"
              },
              {
                "text": "Raichur",
                "link": "https://www.swiggy.com/city/raichur"
              },
              {
                "text": "Bahraich",
                "link": "https://www.swiggy.com/city/bahraich"
              },
              {
                "text": "Azamgarh",
                "link": "https://www.swiggy.com/city/azamgarh"
              },
              {
                "text": "Bahadurgarh",
                "link": "https://www.swiggy.com/city/bahadurgarh"
              },
              {
                "text": "Jind",
                "link": "https://www.swiggy.com/city/jind"
              },
              {
                "text": "Rewari",
                "link": "https://www.swiggy.com/city/rewari"
              },
              {
                "text": "Palwal",
                "link": "https://www.swiggy.com/city/palwal"
              },
              {
                "text": "Hathras",
                "link": "https://www.swiggy.com/city/hathras"
              },
              {
                "text": "Sambalpur",
                "link": "https://www.swiggy.com/city/sambalpur"
              },
              {
                "text": "Banda",
                "link": "https://www.swiggy.com/city/banda"
              },
              {
                "text": "Hoshiarpur",
                "link": "https://www.swiggy.com/city/hoshiarpur"
              },
              {
                "text": "Faridkot",
                "link": "https://www.swiggy.com/city/faridkot"
              },
              {
                "text": "Mandsaur",
                "link": "https://www.swiggy.com/city/mandsaur"
              },
              {
                "text": "Suryapet",
                "link": "https://www.swiggy.com/city/suryapet"
              },
              {
                "text": "Adilabad",
                "link": "https://www.swiggy.com/city/adilabad"
              },
              {
                "text": "Narasaraopet",
                "link": "https://www.swiggy.com/city/narasaraopet"
              },
              {
                "text": "Faizabad",
                "link": "https://www.swiggy.com/city/faizabad"
              },
              {
                "text": "Tadpatri",
                "link": "https://www.swiggy.com/city/tadpatri"
              },
              {
                "text": "Gonda",
                "link": "https://www.swiggy.com/city/gonda"
              },
              {
                "text": "Mughalsarai",
                "link": "https://www.swiggy.com/city/mughalsarai"
              },
              {
                "text": "Medinipur",
                "link": "https://www.swiggy.com/city/medinipur"
              },
              {
                "text": "Nagda",
                "link": "https://www.swiggy.com/city/nagda"
              },
              {
                "text": "Chilakaluripet",
                "link": "https://www.swiggy.com/city/chilakaluripet"
              },
              {
                "text": "Hindupur",
                "link": "https://www.swiggy.com/city/hindupur"
              },
              {
                "text": "Kasganj",
                "link": "https://www.swiggy.com/city/kasganj"
              },
              {
                "text": "Raiganj",
                "link": "https://www.swiggy.com/city/raiganj"
              },
              {
                "text": "Deoria City",
                "link": "https://www.swiggy.com/city/deoria-city"
              },
              {
                "text": "Sultanpur",
                "link": "https://www.swiggy.com/city/sultanpur"
              },
              {
                "text": "Shamli",
                "link": "https://www.swiggy.com/city/shamli"
              },
              {
                "text": "Krishnanagar",
                "link": "https://www.swiggy.com/city/krishnanagar"
              },
              {
                "text": "Ballia",
                "link": "https://www.swiggy.com/city/ballia"
              },
              {
                "text": "Guntakal",
                "link": "https://www.swiggy.com/city/guntakal"
              },
              {
                "text": "Miryalaguda",
                "link": "https://www.swiggy.com/city/miryalaguda"
              },
              {
                "text": "Etah",
                "link": "https://www.swiggy.com/city/etah"
              },
              {
                "text": "Berhampore",
                "link": "https://www.swiggy.com/city/berhampore"
              },
              {
                "text": "Gudivada",
                "link": "https://www.swiggy.com/city/gudivada"
              },
              {
                "text": "Haldia",
                "link": "https://www.swiggy.com/city/haldia"
              },
              {
                "text": "Santipur",
                "link": "https://www.swiggy.com/city/santipur"
              },
              {
                "text": "Basirhat",
                "link": "https://www.swiggy.com/city/basirhat"
              },
              {
                "text": "Seoni",
                "link": "https://www.swiggy.com/city/seoni"
              },
              {
                "text": "Udgir",
                "link": "https://www.swiggy.com/city/udgir"
              },
              {
                "text": "Proddatur",
                "link": "https://www.swiggy.com/city/proddatur"
              },
              {
                "text": "Nagapattinam",
                "link": "https://www.swiggy.com/city/nagapattinam"
              },
              {
                "text": "Chikmagalur",
                "link": "https://www.swiggy.com/city/chikmagalur"
              },
              {
                "text": "Chandausi",
                "link": "https://www.swiggy.com/city/chandausi"
              },
              {
                "text": "Bhind",
                "link": "https://www.swiggy.com/city/bhind"
              },
              {
                "text": "Mandya",
                "link": "https://www.swiggy.com/city/mandya"
              },
              {
                "text": "Bagalkot",
                "link": "https://www.swiggy.com/city/bagalkot"
              },
              {
                "text": "Nandurbar",
                "link": "https://www.swiggy.com/city/nandurbar"
              },
              {
                "text": "Chitradurga",
                "link": "https://www.swiggy.com/city/chitradurga"
              },
              {
                "text": "Osmanabad",
                "link": "https://www.swiggy.com/city/osmanabad"
              },
              {
                "text": "Modinagar",
                "link": "https://www.swiggy.com/city/modinagar"
              },
              {
                "text": "Gadag-Betigeri",
                "link": "https://www.swiggy.com/city/gadag-betigeri"
              },
              {
                "text": "Hoshangabad",
                "link": "https://www.swiggy.com/city/hoshangabad"
              },
              {
                "text": "Jaunpur",
                "link": "https://www.swiggy.com/city/jaunpur"
              },
              {
                "text": "Khurja",
                "link": "https://www.swiggy.com/city/khurja"
              },
              {
                "text": "Port Blair",
                "link": "https://www.swiggy.com/city/port-blair"
              },
              {
                "text": "Jorhat",
                "link": "https://www.swiggy.com/city/jorhat"
              },
              {
                "text": "Nandyal",
                "link": "https://www.swiggy.com/city/nandyal"
              },
              {
                "text": "Biharsharif",
                "link": "https://www.swiggy.com/city/biharsharif"
              },
              {
                "text": "Buxar",
                "link": "https://www.swiggy.com/city/buxar"
              },
              {
                "text": "Siwan",
                "link": "https://www.swiggy.com/city/siwan"
              },
              {
                "text": "Dehri",
                "link": "https://www.swiggy.com/city/dehri"
              },
              {
                "text": "Bettiah",
                "link": "https://www.swiggy.com/city/bettiah"
              },
              {
                "text": "Kishanganj",
                "link": "https://www.swiggy.com/city/kishanganj"
              },
              {
                "text": "Saharsa",
                "link": "https://www.swiggy.com/city/saharsa"
              },
              {
                "text": "Hajipur",
                "link": "https://www.swiggy.com/city/hajipur"
              },
              {
                "text": "Motihari",
                "link": "https://www.swiggy.com/city/motihari"
              },
              {
                "text": "Sasaram",
                "link": "https://www.swiggy.com/city/sasaram"
              },
              {
                "text": "Munger",
                "link": "https://www.swiggy.com/city/munger"
              },
              {
                "text": "Katihar",
                "link": "https://www.swiggy.com/city/katihar"
              },
              {
                "text": "Arrah",
                "link": "https://www.swiggy.com/city/arrah"
              },
              {
                "text": "Srikakulam",
                "link": "https://www.swiggy.com/city/srikakulam"
              },
              {
                "text": "Begusarai",
                "link": "https://www.swiggy.com/city/begusarai"
              },
              {
                "text": "Neyveli",
                "link": "https://www.swiggy.com/city/neyveli"
              },
              {
                "text": "Waidhan",
                "link": "https://www.swiggy.com/city/waidhan"
              },
              {
                "text": "Markapur",
                "link": "https://www.swiggy.com/city/markapur"
              },
              {
                "text": "Chikkaballapur",
                "link": "https://www.swiggy.com/city/chikkaballapur"
              },
              {
                "text": "Bhatkal",
                "link": "https://www.swiggy.com/city/bhatkal"
              },
              {
                "text": "Gokak",
                "link": "https://www.swiggy.com/city/gokak"
              },
              {
                "text": "Itarsi",
                "link": "https://www.swiggy.com/city/itarsi"
              },
              {
                "text": "Dabra",
                "link": "https://www.swiggy.com/city/dabra"
              },
              {
                "text": "Dhar",
                "link": "https://www.swiggy.com/city/dhar"
              },
              {
                "text": "Chalisgaon",
                "link": "https://www.swiggy.com/city/chalisgaon"
              },
              {
                "text": "Thiruvallur",
                "link": "https://www.swiggy.com/city/thiruvallur"
              },
              {
                "text": "Namakkal",
                "link": "https://www.swiggy.com/city/namakkal"
              },
              {
                "text": "Dharmapuri",
                "link": "https://www.swiggy.com/city/dharmapuri"
              },
              {
                "text": "Bhandara",
                "link": "https://www.swiggy.com/city/bhandara"
              },
              {
                "text": "Virudhunagar",
                "link": "https://www.swiggy.com/city/virudhunagar"
              },
              {
                "text": "Siddipet",
                "link": "https://www.swiggy.com/city/siddipet"
              },
              {
                "text": "Gadwal",
                "link": "https://www.swiggy.com/city/gadwal"
              },
              {
                "text": "Bodhan-Rural",
                "link": "https://www.swiggy.com/city/bodhan-rural"
              },
              {
                "text": "Kamareddy",
                "link": "https://www.swiggy.com/city/kamareddy"
              },
              {
                "text": "Jhunjhunu",
                "link": "https://www.swiggy.com/city/jhunjhunu"
              },
              {
                "text": "Kapurthala",
                "link": "https://www.swiggy.com/city/kapurthala"
              },
              {
                "text": "Sangrur",
                "link": "https://www.swiggy.com/city/sangrur"
              },
              {
                "text": "Gurdaspur",
                "link": "https://www.swiggy.com/city/gurdaspur"
              },
              {
                "text": "Ramgarh",
                "link": "https://www.swiggy.com/city/ramgarh"
              },
              {
                "text": "Bantwal",
                "link": "https://www.swiggy.com/city/bantwal"
              },
              {
                "text": "Doddaballapura",
                "link": "https://www.swiggy.com/city/doddaballapura"
              },
              {
                "text": "Buldana",
                "link": "https://www.swiggy.com/city/buldana"
              },
              {
                "text": "Karad",
                "link": "https://www.swiggy.com/city/karad"
              },
              {
                "text": "Krishnagiri",
                "link": "https://www.swiggy.com/city/krishnagiri"
              },
              {
                "text": "Tiptur",
                "link": "https://www.swiggy.com/city/tiptur"
              },
              {
                "text": "Bhadrachalam",
                "link": "https://www.swiggy.com/city/bhadrachalam"
              },
              {
                "text": "Mancherial",
                "link": "https://www.swiggy.com/city/mancherial"
              },
              {
                "text": "Balrampur",
                "link": "https://www.swiggy.com/city/balrampur"
              },
              {
                "text": "Bharabanki",
                "link": "https://www.swiggy.com/city/bharabanki"
              },
              {
                "text": "Malout",
                "link": "https://www.swiggy.com/city/malout"
              },
              {
                "text": "Fatehgarh Sahib",
                "link": "https://www.swiggy.com/city/fatehgarh-sahib"
              },
              {
                "text": "Ropar",
                "link": "https://www.swiggy.com/city/ropar"
              },
              {
                "text": "Nangal",
                "link": "https://www.swiggy.com/city/nangal"
              },
              {
                "text": "Narnaul",
                "link": "https://www.swiggy.com/city/narnaul"
              },
              {
                "text": "Naraingarh",
                "link": "https://www.swiggy.com/city/naraingarh"
              },
              {
                "text": "Himmatnagar",
                "link": "https://www.swiggy.com/city/himmatnagar"
              },
              {
                "text": "Dausa",
                "link": "https://www.swiggy.com/city/dausa"
              },
              {
                "text": "Jahanabad",
                "link": "https://www.swiggy.com/city/jahanabad"
              },
              {
                "text": "Samastipur",
                "link": "https://www.swiggy.com/city/samastipur"
              },
              {
                "text": "Purnea",
                "link": "https://www.swiggy.com/city/purnea"
              },
              {
                "text": "Berhampur",
                "link": "https://www.swiggy.com/city/berhampur"
              },
              {
                "text": "Malda",
                "link": "https://www.swiggy.com/city/malda"
              },
              {
                "text": "Tuni",
                "link": "https://www.swiggy.com/city/tuni"
              },
              {
                "text": "Puttur",
                "link": "https://www.swiggy.com/city/puttur"
              },
              {
                "text": "Rayachoty",
                "link": "https://www.swiggy.com/city/rayachoty"
              },
              {
                "text": "Medak",
                "link": "https://www.swiggy.com/city/medak"
              },
              {
                "text": "Nirmal",
                "link": "https://www.swiggy.com/city/nirmal"
              },
              {
                "text": "Mirzapur",
                "link": "https://www.swiggy.com/city/mirzapur"
              },
              {
                "text": "Tanuku",
                "link": "https://www.swiggy.com/city/tanuku"
              },
              {
                "text": "Dahod",
                "link": "https://www.swiggy.com/city/dahod"
              },
              {
                "text": "Barmer",
                "link": "https://www.swiggy.com/city/barmer"
              },
              {
                "text": "Gangapur City",
                "link": "https://www.swiggy.com/city/gangapur-city"
              },
              {
                "text": "Mandi Gobindgarh",
                "link": "https://www.swiggy.com/city/mandi-gobindgarh"
              },
              {
                "text": "Tarn Taran Sahib",
                "link": "https://www.swiggy.com/city/tarn-taran-sahib"
              },
              {
                "text": "Nakodar",
                "link": "https://www.swiggy.com/city/nakodar"
              },
              {
                "text": "Ankleshwar",
                "link": "https://www.swiggy.com/city/ankleshwar"
              },
              {
                "text": "Vyara",
                "link": "https://www.swiggy.com/city/vyara"
              },
              {
                "text": "Bardoli",
                "link": "https://www.swiggy.com/city/bardoli"
              },
              {
                "text": "Halol",
                "link": "https://www.swiggy.com/city/halol"
              },
              {
                "text": "Bijnor",
                "link": "https://www.swiggy.com/city/bijnor"
              },
              {
                "text": "Sawantwadi",
                "link": "https://www.swiggy.com/city/sawantwadi"
              },
              {
                "text": "Shrirampur",
                "link": "https://www.swiggy.com/city/shrirampur"
              },
              {
                "text": "Sangamner",
                "link": "https://www.swiggy.com/city/sangamner"
              },
              {
                "text": "Baramati",
                "link": "https://www.swiggy.com/city/baramati"
              },
              {
                "text": "Betul",
                "link": "https://www.swiggy.com/city/betul"
              },
              {
                "text": "Chhatarpur",
                "link": "https://www.swiggy.com/city/chhatarpur"
              },
              {
                "text": "Datia",
                "link": "https://www.swiggy.com/city/datia"
              },
              {
                "text": "Balaghat",
                "link": "https://www.swiggy.com/city/balaghat"
              },
              {
                "text": "Sivakasi",
                "link": "https://www.swiggy.com/city/sivakasi"
              },
              {
                "text": "Viluppuram",
                "link": "https://www.swiggy.com/city/viluppuram"
              },
              {
                "text": "Ramanathapuram",
                "link": "https://www.swiggy.com/city/ramanathapuram"
              },
              {
                "text": "Sirsi",
                "link": "https://www.swiggy.com/city/sirsi"
              },
              {
                "text": "Kodaikanal",
                "link": "https://www.swiggy.com/city/kodaikanal"
              },
              {
                "text": "Theni",
                "link": "https://www.swiggy.com/city/theni"
              },
              {
                "text": "Karur",
                "link": "https://www.swiggy.com/city/karur"
              },
              {
                "text": "Karwar",
                "link": "https://www.swiggy.com/city/karwar"
              },
              {
                "text": "Sindhanur",
                "link": "https://www.swiggy.com/city/sindhanur"
              },
              {
                "text": "Kannur",
                "link": "https://www.swiggy.com/city/kannur"
              },
              {
                "text": "Noida 1",
                "link": "https://www.swiggy.com/city/noida-1"
              },
              {
                "text": "Karunagappaly",
                "link": "https://www.swiggy.com/city/karunagappaly"
              },
              {
                "text": "Thiruvalla",
                "link": "https://www.swiggy.com/city/thiruvalla"
              },
              {
                "text": "Thodupuzha",
                "link": "https://www.swiggy.com/city/thodupuzha"
              },
              {
                "text": "Kadiri",
                "link": "https://www.swiggy.com/city/kadiri"
              },
              {
                "text": "Kavali",
                "link": "https://www.swiggy.com/city/kavali"
              },
              {
                "text": "Tezpur",
                "link": "https://www.swiggy.com/city/tezpur"
              },
              {
                "text": "Kayamkulam",
                "link": "https://www.swiggy.com/city/kayamkulam"
              },
              {
                "text": "Kottarakkara",
                "link": "https://www.swiggy.com/city/kottarakkara"
              },
              {
                "text": "Mandi Dabwali",
                "link": "https://www.swiggy.com/city/mandi-dabwali"
              },
              {
                "text": "Fatehabad",
                "link": "https://www.swiggy.com/city/fatehabad"
              },
              {
                "text": "Jagraon",
                "link": "https://www.swiggy.com/city/jagraon"
              },
              {
                "text": "Mansa",
                "link": "https://www.swiggy.com/city/mansa"
              },
              {
                "text": "Pinjore City",
                "link": "https://www.swiggy.com/city/pinjore-city"
              },
              {
                "text": "Fazilka",
                "link": "https://www.swiggy.com/city/fazilka"
              },
              {
                "text": "Baddi",
                "link": "https://www.swiggy.com/city/baddi"
              },
              {
                "text": "Solan",
                "link": "https://www.swiggy.com/city/solan"
              },
              {
                "text": "Daltonganj",
                "link": "https://www.swiggy.com/city/daltonganj"
              },
              {
                "text": "Balangir",
                "link": "https://www.swiggy.com/city/balangir"
              },
              {
                "text": "Paonta Sahib",
                "link": "https://www.swiggy.com/city/paonta-sahib"
              },
              {
                "text": "Kothagudem",
                "link": "https://www.swiggy.com/city/kothagudem"
              },
              {
                "text": "Hansi",
                "link": "https://www.swiggy.com/city/hansi"
              },
              {
                "text": "Aurangabad_Bihar",
                "link": "https://www.swiggy.com/city/aurangabadbihar"
              },
              {
                "text": "Charkhi Dadri",
                "link": "https://www.swiggy.com/city/charkhi-dadri"
              },
              {
                "text": "Gopalganj",
                "link": "https://www.swiggy.com/city/gopalganj"
              },
              {
                "text": "Jharsuguda",
                "link": "https://www.swiggy.com/city/jharsuguda"
              },
              {
                "text": "Tohana",
                "link": "https://www.swiggy.com/city/tohana"
              },
              {
                "text": "Jhalawar",
                "link": "https://www.swiggy.com/city/jhalawar"
              },
              {
                "text": "Sivasagar",
                "link": "https://www.swiggy.com/city/sivasagar"
              },
              {
                "text": "Bagdogra",
                "link": "https://www.swiggy.com/city/bagdogra"
              },
              {
                "text": "Angul",
                "link": "https://www.swiggy.com/city/angul"
              },
              {
                "text": "Kendrapada",
                "link": "https://www.swiggy.com/city/kendrapada"
              },
              {
                "text": "Mallapuram (Do not Use)",
                "link": "https://www.swiggy.com/city/mallapuram-do-not-use"
              },
              {
                "text": "Veraval",
                "link": "https://www.swiggy.com/city/veraval"
              },
              {
                "text": "Daman",
                "link": "https://www.swiggy.com/city/daman"
              },
              {
                "text": "Chiplun",
                "link": "https://www.swiggy.com/city/chiplun"
              },
              {
                "text": "Silvassa",
                "link": "https://www.swiggy.com/city/silvassa"
              },
              {
                "text": "Bapatla&Chirala",
                "link": "https://www.swiggy.com/city/bapatla-and-chirala"
              },
              {
                "text": "Lonavla",
                "link": "https://www.swiggy.com/city/lonavla"
              },
              {
                "text": "Bongaigaon",
                "link": "https://www.swiggy.com/city/bongaigaon"
              },
              {
                "text": "Golaghat",
                "link": "https://www.swiggy.com/city/golaghat"
              },
              {
                "text": "Duliajan",
                "link": "https://www.swiggy.com/city/duliajan"
              },
              {
                "text": "Ramnagar",
                "link": "https://www.swiggy.com/city/ramnagar"
              },
              {
                "text": "Bolpur",
                "link": "https://www.swiggy.com/city/bolpur"
              },
              {
                "text": "Madhubani",
                "link": "https://www.swiggy.com/city/madhubani"
              },
              {
                "text": "Balasore",
                "link": "https://www.swiggy.com/city/balasore"
              },
              {
                "text": "Palampur",
                "link": "https://www.swiggy.com/city/palampur"
              },
              {
                "text": "Kotdwar",
                "link": "https://www.swiggy.com/city/kotdwar"
              },
              {
                "text": "Koppal",
                "link": "https://www.swiggy.com/city/koppal"
              },
              {
                "text": "Chikhli",
                "link": "https://www.swiggy.com/city/chikhli"
              },
              {
                "text": "Dahanu",
                "link": "https://www.swiggy.com/city/dahanu"
              },
              {
                "text": "Itanagar",
                "link": "https://www.swiggy.com/city/itanagar"
              },
              {
                "text": "Rangpo",
                "link": "https://www.swiggy.com/city/rangpo"
              },
              {
                "text": "Aizawl",
                "link": "https://www.swiggy.com/city/aizawl"
              },
              {
                "text": "Gangtok",
                "link": "https://www.swiggy.com/city/gangtok"
              },
              {
                "text": "Mayiladuthurai",
                "link": "https://www.swiggy.com/city/mayiladuthurai"
              },
              {
                "text": "Kannauj",
                "link": "https://www.swiggy.com/city/kannauj"
              },
              {
                "text": "Cooch Behar",
                "link": "https://www.swiggy.com/city/cooch-behar"
              },
              {
                "text": "Jaigaon",
                "link": "https://www.swiggy.com/city/jaigaon"
              },
              {
                "text": "Palani",
                "link": "https://www.swiggy.com/city/palani"
              },
              {
                "text": "Bilimora",
                "link": "https://www.swiggy.com/city/bilimora"
              },
              {
                "text": "Udhampur",
                "link": "https://www.swiggy.com/city/udhampur"
              },
              {
                "text": "Boisar",
                "link": "https://www.swiggy.com/city/boisar"
              },
              {
                "text": "Kohima",
                "link": "https://www.swiggy.com/city/kohima"
              },
              {
                "text": "Naharlagun",
                "link": "https://www.swiggy.com/city/naharlagun"
              },
              {
                "text": "Dumka",
                "link": "https://www.swiggy.com/city/dumka"
              },
              {
                "text": "Rajsamand",
                "link": "https://www.swiggy.com/city/rajsamand"
              },
              {
                "text": "Gauriganj",
                "link": "https://www.swiggy.com/city/gauriganj"
              },
              {
                "text": "Bodinayakanur",
                "link": "https://www.swiggy.com/city/bodinayakanur"
              },
              {
                "text": "Bhawanipatna",
                "link": "https://www.swiggy.com/city/bhawanipatna"
              },
              {
                "text": "Baran",
                "link": "https://www.swiggy.com/city/baran"
              },
              {
                "text": "Narsinghpur",
                "link": "https://www.swiggy.com/city/narsinghpur"
              },
              {
                "text": "Uran Islampur",
                "link": "https://www.swiggy.com/city/uran-islampur"
              },
              {
                "text": "Kovilpatti",
                "link": "https://www.swiggy.com/city/kovilpatti"
              },
              {
                "text": "Kasaragod",
                "link": "https://www.swiggy.com/city/kasaragod"
              },
              {
                "text": "Pusad",
                "link": "https://www.swiggy.com/city/pusad"
              },
              {
                "text": "Kendujhar",
                "link": "https://www.swiggy.com/city/kendujhar"
              },
              {
                "text": "Manali",
                "link": "https://www.swiggy.com/city/manali"
              },
              {
                "text": "Diu",
                "link": "https://www.swiggy.com/city/diu"
              },
              {
                "text": "Khamgaon",
                "link": "https://www.swiggy.com/city/khamgaon"
              },
              {
                "text": "Ramanagara",
                "link": "https://www.swiggy.com/city/ramanagara"
              },
              {
                "text": "Alipurduar",
                "link": "https://www.swiggy.com/city/alipurduar"
              },
              {
                "text": "Almora",
                "link": "https://www.swiggy.com/city/almora"
              },
              {
                "text": "Jhargram",
                "link": "https://www.swiggy.com/city/jhargram"
              },
              {
                "text": "Arambagh",
                "link": "https://www.swiggy.com/city/arambagh"
              },
              {
                "text": "Bhadohi",
                "link": "https://www.swiggy.com/city/bhadohi"
              },
              {
                "text": "Tenkasi",
                "link": "https://www.swiggy.com/city/tenkasi"
              },
              {
                "text": "Srivilliputhur",
                "link": "https://www.swiggy.com/city/srivilliputhur"
              },
              {
                "text": "Chidambaram",
                "link": "https://www.swiggy.com/city/chidambaram"
              },
              {
                "text": "Rajgarh",
                "link": "https://www.swiggy.com/city/rajgarh"
              },
              {
                "text": "Pratapgarh",
                "link": "https://www.swiggy.com/city/pratapgarh"
              },
              {
                "text": "Washim",
                "link": "https://www.swiggy.com/city/washim"
              },
              {
                "text": "Mandi HP",
                "link": "https://www.swiggy.com/city/mandi-hp"
              },
              {
                "text": "Ranaghat",
                "link": "https://www.swiggy.com/city/ranaghat"
              },
              {
                "text": "Raghunathpur",
                "link": "https://www.swiggy.com/city/raghunathpur"
              },
              {
                "text": "Suri",
                "link": "https://www.swiggy.com/city/suri"
              },
              {
                "text": "Kadayanallur",
                "link": "https://www.swiggy.com/city/kadayanallur"
              },
              {
                "text": "Thiruvarur",
                "link": "https://www.swiggy.com/city/thiruvarur"
              },
              {
                "text": "Ranaghat-WB",
                "link": "https://www.swiggy.com/city/ranaghat-wb"
              },
              {
                "text": "Idukki",
                "link": "https://www.swiggy.com/city/idukki"
              },
              {
                "text": "Wayanad",
                "link": "https://www.swiggy.com/city/wayanad"
              },
              {
                "text": "Perambalur",
                "link": "https://www.swiggy.com/city/perambalur"
              },
              {
                "text": "Paramakudi",
                "link": "https://www.swiggy.com/city/paramakudi"
              },
              {
                "text": "Khopoli",
                "link": "https://www.swiggy.com/city/khopoli"
              },
              {
                "text": "Bela Pratapgarh",
                "link": "https://www.swiggy.com/city/bela-pratapgarh"
              },
              {
                "text": "Mahoba",
                "link": "https://www.swiggy.com/city/mahoba"
              },
              {
                "text": "Sitamarhi",
                "link": "https://www.swiggy.com/city/sitamarhi"
              },
              {
                "text": "Chakdaha",
                "link": "https://www.swiggy.com/city/chakdaha"
              },
              {
                "text": "Khalilabad",
                "link": "https://www.swiggy.com/city/khalilabad"
              },
              {
                "text": "Pattukkottai",
                "link": "https://www.swiggy.com/city/pattukkottai"
              },
              {
                "text": "Tindivanam",
                "link": "https://www.swiggy.com/city/tindivanam"
              },
              {
                "text": "Tiruttani",
                "link": "https://www.swiggy.com/city/tiruttani"
              },
              {
                "text": "Gangarampur",
                "link": "https://www.swiggy.com/city/gangarampur"
              },
              {
                "text": "Dharapuram",
                "link": "https://www.swiggy.com/city/dharapuram"
              },
              {
                "text": "Arakkonam",
                "link": "https://www.swiggy.com/city/arakkonam"
              },
              {
                "text": "Sirkali",
                "link": "https://www.swiggy.com/city/sirkali"
              },
              {
                "text": "Aruppukottai",
                "link": "https://www.swiggy.com/city/aruppukottai"
              },
              {
                "text": "Mettupalayam",
                "link": "https://www.swiggy.com/city/mettupalayam"
              },
              {
                "text": "Digboi",
                "link": "https://www.swiggy.com/city/digboi"
              },
              {
                "text": "Biswanath Chariali",
                "link": "https://www.swiggy.com/city/biswanath-chariali"
              },
              {
                "text": "Nalbari",
                "link": "https://www.swiggy.com/city/nalbari"
              },
              {
                "text": "Shirdi city",
                "link": "https://www.swiggy.com/city/shirdi-city"
              },
              {
                "text": "Mukerian",
                "link": "https://www.swiggy.com/city/mukerian"
              },
              {
                "text": "Hosur",
                "link": "https://www.swiggy.com/city/hosur"
              },
              {
                "text": "Palakollu",
                "link": "https://www.swiggy.com/city/palakollu"
              },
              {
                "text": "Amalapuram",
                "link": "https://www.swiggy.com/city/amalapuram"
              },
              {
                "text": "Ravulapalem",
                "link": "https://www.swiggy.com/city/ravulapalem"
              },
              {
                "text": "Narsipatnam",
                "link": "https://www.swiggy.com/city/narsipatnam"
              },
              {
                "text": "Barh",
                "link": "https://www.swiggy.com/city/barh"
              },
              {
                "text": "Palghar",
                "link": "https://www.swiggy.com/city/palghar"
              },
              {
                "text": "Shahdol",
                "link": "https://www.swiggy.com/city/shahdol"
              },
              {
                "text": "Kushalnagar",
                "link": "https://www.swiggy.com/city/kushalnagar"
              },
              {
                "text": "Dungarpur",
                "link": "https://www.swiggy.com/city/dungarpur"
              },
              {
                "text": "Chaibasa",
                "link": "https://www.swiggy.com/city/chaibasa"
              },
              {
                "text": "Haveri",
                "link": "https://www.swiggy.com/city/haveri"
              },
              {
                "text": "Karaikal",
                "link": "https://www.swiggy.com/city/karaikal"
              },
              {
                "text": "Jjajjar",
                "link": "https://www.swiggy.com/city/jjajjar"
              },
              {
                "text": "Kokrajhar",
                "link": "https://www.swiggy.com/city/kokrajhar"
              },
              {
                "text": "Rangia",
                "link": "https://www.swiggy.com/city/rangia"
              },
              {
                "text": "Hamirpur",
                "link": "https://www.swiggy.com/city/hamirpur"
              },
              {
                "text": "Una",
                "link": "https://www.swiggy.com/city/una"
              },
              {
                "text": "Sulthan Bathery",
                "link": "https://www.swiggy.com/city/sulthan-bathery"
              },
              {
                "text": "Rayagada",
                "link": "https://www.swiggy.com/city/rayagada"
              },
              {
                "text": "Paradeep",
                "link": "https://www.swiggy.com/city/paradeep"
              },
              {
                "text": "Mandapeta",
                "link": "https://www.swiggy.com/city/mandapeta"
              },
              {
                "text": "Jamui",
                "link": "https://www.swiggy.com/city/jamui"
              },
              {
                "text": "Pilkhuwa",
                "link": "https://www.swiggy.com/city/pilkhuwa"
              },
              {
                "text": "Parvathipuram",
                "link": "https://www.swiggy.com/city/parvathipuram"
              },
              {
                "text": "Ambajogai",
                "link": "https://www.swiggy.com/city/ambajogai"
              },
              {
                "text": "Araria",
                "link": "https://www.swiggy.com/city/araria"
              },
              {
                "text": "North Lakhimpur",
                "link": "https://www.swiggy.com/city/north-lakhimpur"
              },
              {
                "text": "Rajampet",
                "link": "https://www.swiggy.com/city/rajampet"
              },
              {
                "text": "Udumalaipettai",
                "link": "https://www.swiggy.com/city/udumalaipettai"
              },
              {
                "text": "Tirupattur",
                "link": "https://www.swiggy.com/city/tirupattur"
              },
              {
                "text": "Hojai",
                "link": "https://www.swiggy.com/city/hojai"
              },
              {
                "text": "Khagaria",
                "link": "https://www.swiggy.com/city/khagaria"
              },
              {
                "text": "Dasuya",
                "link": "https://www.swiggy.com/city/dasuya"
              },
              {
                "text": "Gudur",
                "link": "https://www.swiggy.com/city/gudur"
              },
              {
                "text": "Sullurpeta",
                "link": "https://www.swiggy.com/city/sullurpeta"
              },
              {
                "text": "Piler",
                "link": "https://www.swiggy.com/city/piler"
              },
              {
                "text": "SankaranKoil",
                "link": "https://www.swiggy.com/city/sankarankoil"
              },
              {
                "text": "Nabha",
                "link": "https://www.swiggy.com/city/nabha"
              },
              {
                "text": "LPU - Phagwara",
                "link": "https://www.swiggy.com/city/lpu-phagwara"
              },
              {
                "text": "Jangipur",
                "link": "https://www.swiggy.com/city/jangipur"
              },
              {
                "text": "Roha",
                "link": "https://www.swiggy.com/city/roha"
              },
              {
                "text": "Maharajganj",
                "link": "https://www.swiggy.com/city/maharajganj"
              },
              {
                "text": "Kallakurichi",
                "link": "https://www.swiggy.com/city/kallakurichi"
              },
              {
                "text": "Kalimpong",
                "link": "https://www.swiggy.com/city/kalimpong"
              },
              {
                "text": "Sundernagar",
                "link": "https://www.swiggy.com/city/sundernagar"
              },
              {
                "text": "Nawada",
                "link": "https://www.swiggy.com/city/nawada"
              },
              {
                "text": "Forbesganj",
                "link": "https://www.swiggy.com/city/forbesganj"
              },
              {
                "text": "Mokameh Khas",
                "link": "https://www.swiggy.com/city/mokameh-khas"
              },
              {
                "text": "Bazpur",
                "link": "https://www.swiggy.com/city/bazpur"
              },
              {
                "text": "Lakhisarai",
                "link": "https://www.swiggy.com/city/lakhisarai"
              },
              {
                "text": "Rameswaram",
                "link": "https://www.swiggy.com/city/rameswaram"
              },
              {
                "text": "Sahjanwa",
                "link": "https://www.swiggy.com/city/sahjanwa"
              },
              {
                "text": "Siddharthnagar",
                "link": "https://www.swiggy.com/city/siddharthnagar"
              },
              {
                "text": "Nanjangud",
                "link": "https://www.swiggy.com/city/nanjangud"
              },
              {
                "text": "Chamarajanagar",
                "link": "https://www.swiggy.com/city/chamarajanagar"
              },
              {
                "text": "Kurali",
                "link": "https://www.swiggy.com/city/kurali"
              },
              {
                "text": "Sundar Nagar",
                "link": "https://www.swiggy.com/city/sundar-nagar"
              },
              {
                "text": "Bobbili",
                "link": "https://www.swiggy.com/city/bobbili"
              },
              {
                "text": "Jangaon",
                "link": "https://www.swiggy.com/city/jangaon"
              },
              {
                "text": "Banswara",
                "link": "https://www.swiggy.com/city/banswara"
              },
              {
                "text": "Sundergarh",
                "link": "https://www.swiggy.com/city/sundergarh"
              },
              {
                "text": "Godda",
                "link": "https://www.swiggy.com/city/godda"
              },
              {
                "text": "Madhupur",
                "link": "https://www.swiggy.com/city/madhupur"
              },
              {
                "text": "Katwa",
                "link": "https://www.swiggy.com/city/katwa"
              },
              {
                "text": "Dhupguri",
                "link": "https://www.swiggy.com/city/dhupguri"
              },
              {
                "text": "Contai",
                "link": "https://www.swiggy.com/city/contai"
              },
              {
                "text": "Baramulla",
                "link": "https://www.swiggy.com/city/baramulla"
              },
              {
                "text": "Kangeyam",
                "link": "https://www.swiggy.com/city/kangeyam"
              },
              {
                "text": "Naugachia",
                "link": "https://www.swiggy.com/city/naugachia"
              },
              {
                "text": "Madhepura",
                "link": "https://www.swiggy.com/city/madhepura"
              },
              {
                "text": "Jamkhambhaliya",
                "link": "https://www.swiggy.com/city/jamkhambhaliya"
              },
              {
                "text": "Mundra",
                "link": "https://www.swiggy.com/city/mundra"
              },
              {
                "text": "Patan",
                "link": "https://www.swiggy.com/city/patan"
              },
              {
                "text": "Mahuva",
                "link": "https://www.swiggy.com/city/mahuva"
              },
              {
                "text": "Attur",
                "link": "https://www.swiggy.com/city/attur"
              },
              {
                "text": "Pen",
                "link": "https://www.swiggy.com/city/pen"
              },
              {
                "text": "Mandla",
                "link": "https://www.swiggy.com/city/mandla"
              },
              {
                "text": "Sidhi",
                "link": "https://www.swiggy.com/city/sidhi"
              },
              {
                "text": "Lakshadweep",
                "link": "https://www.swiggy.com/city/lakshadweep"
              },
              {
                "text": "Chitrakoot",
                "link": "https://www.swiggy.com/city/chitrakoot"
              },
              {
                "text": "Rajam",
                "link": "https://www.swiggy.com/city/rajam"
              },
              {
                "text": "Nippani",
                "link": "https://www.swiggy.com/city/nippani"
              },
              {
                "text": "Sankeshwar",
                "link": "https://www.swiggy.com/city/sankeshwar"
              },
              {
                "text": "Chikkodi",
                "link": "https://www.swiggy.com/city/chikkodi"
              },
              {
                "text": "Modasa",
                "link": "https://www.swiggy.com/city/modasa"
              },
              {
                "text": "Bavla",
                "link": "https://www.swiggy.com/city/bavla"
              },
              {
                "text": "Puttur_AP",
                "link": "https://www.swiggy.com/city/puttur-ap"
              },
              {
                "text": "Sinnar",
                "link": "https://www.swiggy.com/city/sinnar"
              },
              {
                "text": "singur",
                "link": "https://www.swiggy.com/city/singur"
              },
              {
                "text": "Nelamangala",
                "link": "https://www.swiggy.com/city/nelamangala"
              },
              {
                "text": "Srinagar Uttarakhand",
                "link": "https://www.swiggy.com/city/srinagar-uttarakhand"
              },
              {
                "text": "Dhampur",
                "link": "https://www.swiggy.com/city/dhampur"
              }
            ]